import Link from "next/link";
import {
  IOfferModeWithFSecure,
  modeToWord,
} from "@nju/data-access-portal-offers";
import {
  IFtthOrchestrator,
  IMobileOrchestrator,
} from "@nju/data-access-portal-orchestrator";
import { portalRoutes } from "@nju/routes";
import { A, BlockText, Button, Panel, Separator, Text } from "@nju/ui";

interface ICancelOrderFormProps {
  isLoading: boolean;
  submit: () => void;
  mode: IOfferModeWithFSecure;
  processId:
    | IMobileOrchestrator["processId"]
    | IFtthOrchestrator["processId"]
    | undefined;
}

export function CancelOrderForm({
  isLoading,
  submit,
  mode,
  processId,
}: ICancelOrderFormProps) {
  const ftthContent = `Oznacza to rezygnację z instalacji usługi nju ${modeToWord(
    mode,
  )}.`;
  const mobileContent = (
    <>
      <Text size={{ "@fromTablet": "l" }}>Za chwilę anulujesz</Text>{" "}
      <Text size={{ "@fromTablet": "l" }} weight="bold">
        całe rozpoczęte zamówienie
      </Text>{" "}
      {processId === "MNP_IN" && "przeniesienia numeru "}
      <Text size={{ "@fromTablet": "l" }}>
        bez możliwości powrotu i jakichkolwiek zmian.
      </Text>
      <BlockText className="pt-4" size={{ "@fromTablet": "l" }}>
        Na pewno chcesz anulować zamówienie?
      </BlockText>
    </>
  );
  const fSecureContent = (
    <>
      <Text size={{ "@fromTablet": "l" }}>
        Za chwilę anulujesz rozpoczęte zamówienie
      </Text>{" "}
      {processId === "MNP_IN" && "przeniesienia numeru "}
      <Text size={{ "@fromTablet": "l" }}>
        bez możliwości powrotu i jakichkolwiek zmian.
      </Text>
      <BlockText className="pt-4" size={{ "@fromTablet": "l" }}>
        Na pewno chcesz anulować zamówienie?
      </BlockText>
    </>
  );

  return (
    <Panel>
      <form data-cy="confirm-cancellation-window">
        <Text
          size={{
            "@onlyMobile": "xl",
            "@fromTablet": "keyM",
          }}
          weight="bold"
        >
          czy na pewno chcesz anulować zamówienie?
        </Text>
        <Separator size="xs" tone="invisible" />
        <BlockText
          className="whitespace-pre-line"
          size={{ "@fromTablet": "l" }}
        >
          {mode === "ftth" && ftthContent}
          {["mobile", "postpaid"].includes(mode) && mobileContent}
          {mode === "fsecure" && fSecureContent}
        </BlockText>
        <Separator size="s" tone="invisible" />
        <div className="flex justify-between only-mobile:flex-col-reverse">
          <Link
            href={portalRoutes.mojeKonto.index.get({
              mode,
              ...(["mobile", "postpaid"].includes(mode) && {
                flow: "multiOrder",
              }),
            })}
            passHref={true}
          >
            <A
              className="only-mobile:mt-3"
              size={{
                "@onlyMobile": "s",
                "@fromTablet": "m",
              }}
              variant="secondary"
            >
              nie, wróć
            </A>
          </Link>
          <Button
            isLoading={isLoading}
            onPress={submit}
            size={{
              "@onlyMobile": "s",
              "@fromTablet": "m",
            }}
            testId="confirm-cancel-order-button"
            variant="primary"
          >
            {processId !== "MNP_IN"
              ? "tak, anuluj zamówienie"
              : "tak, anuluj obecne zamówienie"}
          </Button>
        </div>
      </form>
    </Panel>
  );
}
